module.exports = __webpack_public_path__ + "img/229.e62c575c.png";